export const SEARCHING_BY_ID_API_REQUEST = "SEARCHING_BY_ID_API_REQUEST";
export const SEARCHING_BY_ID_API_SUCCESS = "SEARCHING_BY_ID_API_SUCCESS";
export const SEARCHING_BY_ID_API_ERROR = "SEARCHING_BY_ID_API_ERROR";
export const SEARCHING_BY_LABEL_API_REQUEST = "SEARCHING_BY_LABEL_API_REQUEST";
export const SEARCHING_BY_LABEL_API_SUCCESS = "SEARCHING_BY_LABEL_API_SUCCESS";
export const SEARCHING_BY_LABEL_API_ERROR = "SEARCHING_BY_LABEL_API_ERROR";
export const CONNECT_DEALER_TO_ENGINE_API_REQUEST = "CONNECT_DEALER_TO_ENGINE_API_REQUEST";
export const CONNECT_DEALER_TO_ENGINE_API_SUCCESS = "CONNECT_DEALER_TO_ENGINE_API_SUCCESS";
export const CONNECT_DEALER_TO_ENGINE_API_ERROR = "CONNECT_DEALER_TO_ENGINE_API_ERROR";
export const CONNECT_DEALER_CLEAN_STATE = "CONNECT_DEALER_CLEAN_STATE";
export const CLEAN_STATE = "CLEAN_STATE";
export const CLEAN_SEARCHRESULTS = "CLEAN_SEARCHRESULTS";


export const DISCONNECT_DEALER_TO_ENGINE_API_REQUEST = "DISCONNECT_DEALER_TO_ENGINE_API_REQUEST";
export const DISCONNECT_DEALER_TO_ENGINE_API_SUCCESS = "DISCONNECT_DEALER_TO_ENGINE_API_SUCCESS";
export const DISCONNECT_DEALER_TO_ENGINE_API_ERROR = "DISCONNECT_DEALER_TO_ENGINE_API_ERROR";